import { logEvent, useTranslation } from "react-migration/lib";

export const CommunityButton = () => {
  const { t } = useTranslation();
  const onClickCommunityLink = () => {
    logEvent("Community Link Clicked", { from: "nav" });
  };
  return (
    <div data-testid="community-button">
      <a
        className="action-item atlas-text-neutral-300 hover:atlas-text-content-inverse-primary atlas-text-2xl atlas-mx-2 atlas-hidden md:atlas-flex atlas-items-center"
        href={t("nav.nav.community_link")}
        rel="noopener noreferrer"
        target="_blank"
        title={t("nav.nav.community")}
        onClick={onClickCommunityLink}
      >
        <i className="icon-lt-community-people-line" />
        <span className="atlas-text-sm atlas-pl-2 atlas-hidden lg:atlas-block">
          {t("nav.nav.community")}
        </span>
      </a>
    </div>
  );
};
